import React, { useState } from 'react';
import { serviceImages } from '../../api/service';
import ServiceSingle from '../ServiceSingle';
import { useLanguage } from '../../i18n/LanguageContext';

const serviceAccents = ['#06b6d4', '#8b5cf6', '#06b6d4', '#8b5cf6'];

const ServiceSection = (props) => {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const services = (t.servicesData ?? []).map((s) => ({ ...s, ...serviceImages[s.id] }));
  const selectedService = services.find((service) => service.id === selectedId) || {};
  const selectedIndex = services.findIndex((service) => service.id === selectedId);

  const handleOpen = (item) => { setOpen(true); setSelectedId(item.id); };
  const handleClose = () => setOpen(false);

  return (
    <div className={`wpo-service-area section-padding ${props.sClass || ''}`} id="service">
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '56px' }}>
          <span className="section-label">{t.services?.sectionLabel}</span>
          <h2 style={{ color: '#f1f5f9', fontSize: '36px', fontWeight: 800, margin: 0 }}>
            {t.services?.sectionTitle}
          </h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px' }}>
          {services.map((service, i) => (
            <div
              key={service.id}
              className="service-card-b2b"
              style={{
                background: '#0f172a',
                border: `1px solid #1e293b`,
                borderTop: `3px solid ${serviceAccents[i % 4]}`,
                borderRadius: '12px',
                padding: '28px 28px 24px',
                transition: 'border-color 0.3s, transform 0.3s',
                cursor: 'pointer',
              }}
              onClick={() => handleOpen(service)}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = serviceAccents[i % 4]; e.currentTarget.style.transform = 'translateY(-3px)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#1e293b'; e.currentTarget.style.transform = 'none'; e.currentTarget.style.borderTopColor = serviceAccents[i % 4]; }}
            >
              <div style={{ marginBottom: '14px' }}>
                <i className={`fi ${service.icon}`} style={{ fontSize: '28px', color: serviceAccents[i % 4] }}></i>
              </div>
              <h3 style={{ color: '#f1f5f9', fontSize: '18px', fontWeight: 700, margin: '0 0 10px' }}>
                {service.title}
              </h3>
              <p style={{ color: '#475569', fontSize: '14px', lineHeight: '1.7', margin: '0 0 16px' }}>
                {service.description}
              </p>
              <span style={{ color: serviceAccents[i % 4], fontSize: '13px', fontWeight: 600 }}>
                {t.services?.learnMore} &rarr;
              </span>
            </div>
          ))}
        </div>
      </div>
      <ServiceSingle
        open={open}
        onClose={handleClose}
        title={selectedService.title}
        description={selectedService.description}
        dImg={selectedService.sImgS}
        icon={selectedService.icon}
        accent={serviceAccents[selectedIndex % 4] || '#06b6d4'}
        stat={selectedService.stat}
        mainDescription={selectedService.mainDescription}
        scopeDescription={selectedService.scopeDescription}
        capabilities={selectedService.capabilities}
        capabilitiesDescription={selectedService.capabilitiesDescription}
        approach={selectedService.approach}
        workProcess={selectedService.workProcess}
      />
    </div>
  );
};

export default ServiceSection;
